<script>
import { BaseService } from '@services/BaseService.js'
import { formatDateMoment } from '@utils/format-date'
import getPropByString from '@utils/get-prop-by-string.js'
import FilePreviewImage from '../file-preview-image.vue'
import FilePreviewPdf from '../file-preview-pdf.vue'
import { healthRecordService } from '@services/safehaven/HealthRecordService'
import store from '@state/store'
import axios from 'axios'

export default {
  components: { FilePreviewImage, FilePreviewPdf },
  props: {
    pdfrecords: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      default: 'List',
    },
    subtitle: {
      type: String,
      default: 'List',
    },

    image: {
      type: String,
      required: false,
      default: '',
    },
    resource: {
      type: String,
      required: true,
      default: '',
    },
    records: {
      type: Array,
      required: false,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    sortables: {
      type: Object,
      default: null,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    color: {
      type: String,
      default: '#14142B',
    },
    opaque: {
      type: String,
      default: '#FCFCFC',
    },
    shared: {
      type: Boolean,
      default: false,
    },
    recipientid: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      baseService: null,
      expanded: false,
      items: [],
      itemsPerPage: [5, 10, 20, 50],
      options: {
        searchQuery: '',
        sortBy: [],
        sortDesc: [],
      },
      pagination: {
        offset: 0,
        total: 0,
        limit: 9999,
      },
      loading: true,
      hoverHeader: '',
      acceptedTypes: ['jpg', 'jpeg', 'png'],
      imageDialog: false,
      pdfDialog: false,
      toPreview: {},
      hRecords: [],
    }
  },

  computed: {
    computeHeaders() {
      if (this.headers.length) {
        return this.headers
          .filter((el) => {
            return el.value !== 'actions'
          })
          .map((el) => {
            el.text = this.$t(el.text)
            return el
          })
      } else if (this.items.length) {
        return Object.keys(this.items[0]).map((e, idx) => {
          return {
            text: this.$t(`datatable.headers.${this.resource}.${e}`),
            value: e,
          }
        })
      } else {
        return []
      }
    },
  },
  watch: {
    '$store.state.calender.expandAll': function() {
      if (store.state.calender.expandAll === 'true') this.expanded = true
      else if (store.state.calender.expandAll === 'false') this.expanded = false
    },
    '$store.state.healthrecords.actionStatus': function() {
      if (
        store.state.healthrecords.actionStatus &&
        store.state.healthrecords.actionStatus.action === 'remove' &&
        store.state.healthrecords.actionStatus.status
      ) {
        const item = store.state.healthrecords.actionStatus.item
        const itemId = this.items.findIndex((el) => el.hr_id === item.hr_id)
        if (itemId >= 0) {
          this.items.splice(itemId, 1)
          this.restoreHRecords(item.hr_id)
          store.dispatch('healthrecords/setActionStatus', null)
        }
      }
    },
    reload: {
      handler() {
        this.fetch()
      },
    },
    options: {
      handler() {
        this.fetch()
      },
      deep: true,
    },
  },
  mounted() {
    this.baseService = new BaseService(this.resource)

    this.fetch()
  },
  methods: {
    formatDateMoment,
    show(item) {
      this.$emit('show-item', { item: item, resource: this.resource })
    },
    addItem() {
      this.$emit('add-item', { resource: this.resource })
    },
    remove(item) {
      this.$emit('delete-item', { item: item, resource: this.resource })
    },
    restoreHRecords(removingItemId) {
      const healthRecord = healthRecordService.getHealthRecordData()
      const pos = healthRecord.results.findIndex(
        (el) => el.hr_id === removingItemId
      )
      healthRecord.results.splice(pos, 1)
      healthRecord.count = healthRecord.count - 1
      healthRecordService.setHealthRecordData(healthRecord)
    },
    async fetch() {
      try {
        this.loading = true
        let { sortBy } = this.options

        if (sortBy.length && this.sortables) {
          sortBy = sortBy.map((x) => getPropByString(this.sortables, x))
        }

        const data = []
        this.items = []
        healthRecordService.getHealthRecordData().results.forEach((parent) => {
          if ('hr/' + parent.record_type + '/' === this.resource)
            data.push(parent)
        })
        if (data[0]) {
          this.items = data
          this.items.forEach((child) => {
            child.attachments.reverse()
          })

          if (this.items.length) this.$emit('has-data', 1)
          else this.$emit('has-data', 0)
          this.loading = false
        } else if (this.resource === 'hr/symptomcheaker/') {
          this.items = data
          if (this.items.length) this.$emit('has-data', 1)
          else this.$emit('has-data', 0)
          this.loading = false
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.loading = false
      }
    },
    orderBy(header) {
      if (!this.options.sortBy.length && !this.options.sortDesc.length) {
        this.$set(this.options.sortBy, 0, header.value)
        this.$set(this.options.sortDesc, 0, false)
      } else if (
        this.options.sortBy.length &&
        this.options.sortBy[0] === header.value &&
        this.options.sortDesc.length
      ) {
        if (this.options.sortDesc[0]) {
          this.options.sortDesc.splice(0)
          this.options.sortBy.splice(0)
        } else {
          this.$set(this.options.sortDesc, 0, true)
        }
      } else {
        this.$set(this.options.sortBy, 0, header.value)
        this.$set(this.options.sortDesc, 0, false)
      }
    },
    /* todo: instead of header index, change main column in headers array to 'label' (the generic hr label)
         and calculate width by header type
       */
    columnsByIndex(index) {
      switch (index) {
        case 0:
          return '4'
        default:
          return ''
      }
    },
    attachmentIcon(attachment) {
      if (attachment.extension === 'pdf') {
        return { icon: 'mdi-file-pdf-outline', color: 'red' }
      } else if (
        attachment.extension === 'jpg' ||
        attachment.extension === 'png' ||
        attachment.extension === 'jpeg'
      ) {
        return { icon: 'mdi-file-image-outline', color: 'primary' }
      } else {
        return { icon: 'mdi-file-outline', color: 'body' }
      }
    },
    preview(attachment, attachments) {
      this.toPreview = attachment
      this.hrecords = this.records.find((x) => {
        return x.attachments.length
          ? x.attachments[0].id === attachment.id
          : null
      })
      if (attachment.extension === 'pdf') {
        this.pdfDialog = true
      } else {
        if (this.acceptedTypes.includes(attachment.extension)) {
          this.imageDialog = true
        } else {
          this.download(attachment)
        }
      }
    },

    previewSympDoc(attachment) {
      this.toPreview = attachment

      this.pdfDialog = true
    },
    goToAttachments(item) {
      this.$emit('show-item', {
        item: item,
        resource: this.resource,
        attachments: true,
      })
    },
    async download(attachment) {
      try {
        let data
        if (this.shared) {
          data = await axios.post(`/api/v1/library/shared/hr/files/`, {
            file_id: attachment.id,
            recipient_information_id: this.recipientid,
          })
        } else {
          data = await axios.get(`/api/v1/library/files/${attachment.id}`)
        }
        const res = await fetch(data.data.url)
        const blob = await res.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.warn(error)
      }
    },

    validateField(header, item) {
      let itemDate = ''
      let field = ''
      let record = null
      if (header.text.toLowerCase().includes('date')) {
        itemDate = header.value.split('.').reduce((o, i) => {
          field = i
          record = o
          return o[i] || ''
        }, item)
        if (itemDate === '') {
          if (field.toLowerCase().includes('start')) {
            if (record.start_date_part === 'past') return 'In the past'
          } else if (field.toLowerCase().includes('end')) {
            if (record.end_date_part === 'past') return 'In the past'
          } else if (record.date_part === 'past') return 'In the past'
        } else {
          return formatDateMoment(itemDate, 'MM/DD/yyyy')
        }
      } else {
        return header.value.split('.').reduce((o, i) => o[i] || '', item)
      }
    },
  },
}
</script>

<template>
  <v-container fluid :class="$style.containerClass">
    <!-- file preview dialogs -->
    <div>
      <v-dialog
        :value="imageDialog"
        :fullscreen="true"
        dark
        persistent
        no-click-animation
        transition="fade-transition"
      >
        <FilePreviewImage
          v-if="imageDialog"
          :attachment-id="toPreview.id"
          :title="toPreview.name"
          :type="toPreview.extension"
          :src="toPreview.url"
          :attachments="shared ? [hrecords] : []"
          :resource="shared ? 'unauth' : null"
          :recipientid="recipientid"
          @closeOverlay="imageDialog = false"
        />
      </v-dialog>
      <v-dialog
        :value="pdfDialog"
        :fullscreen="true"
        dark
        persistent
        no-click-animation
        transition="fade-transition"
      >
        <FilePreviewPdf
          v-if="pdfDialog"
          :attachment-id="toPreview.id"
          :attachments="shared ? [hrecords] : []"
          :resource="shared ? 'unauth' : null"
          :recipient-id="recipientid"
          :urlsym="toPreview.document_path ? toPreview.document_path : null"
          @closeOverlay="pdfDialog = false"
        />
      </v-dialog>
      <v-row class="mb-3" no-gutters>
        <div
          class="d-flex clickableSaafe"
          @click="
            ;(expanded = !expanded),
              $store.dispatch('calender/setExpandAll', 'null')
          "
        >
          <img v-if="image" class="mt-2 imagesClass" :src="image" />

          <div id="recordTitle" class="offblack--text" :class="$style.title"
            >{{ title }} ({{
              title !== 'Symptom Checker' ? items.length : pdfrecords.length
            }})</div
          >
          <v-icon
            class="my-auto-Saafe"
            color="primary"
            :class="expanded ? $style.active : ''"
            >mdi-menu-down</v-icon
          >
        </div>
      </v-row>
      <v-fade-transition v-if="$vuetify.breakpoint.xs" mode="out-in">
        <v-row no-gutters
          ><v-card
            v-if="expanded"
            width="100%"
            min-height="200"
            color="offwhite"
            outlined
            rounded="lg"
            loading
          >
            <template slot="progress">
              <v-progress-linear
                v-if="loading"
                color="primary"
                indeterminate
              ></v-progress-linear>
              <div v-else :class="$style.loaderPlaceholder"></div>
            </template>
            <v-card-text>
              <v-list color="offwhite">
                <v-row
                  class="pb-2"
                  :class="$style.headerRow"
                  justify="space-between"
                  no-gutters
                >
                  <v-col
                    v-for="(header, index) in computeHeaders"
                    :key="header.value"
                    cols="12"
                    :sm="columnsByIndex(index)"
                  >
                    <div
                      v-if="
                        header.value !== 'icon' && header.value !== 'actions'
                      "
                      class="clickableSaafe"
                      :class="
                        !options.sortBy.length ||
                        options.sortBy[0] !== header.value
                          ? ''
                          : 'font-weight-bold'
                      "
                      @mouseenter="hoverHeader = header.value"
                      @mouseleave="hoverHeader = ''"
                      @click="orderBy(header)"
                    >
                      <v-icon
                        v-show="
                          options.sortBy[0] === header.value ||
                            hoverHeader === header.value
                        "
                        class="my-auto-Saafe"
                        color="primary"
                        :disabled="
                          !options.sortBy.length ||
                            options.sortBy[0] !== header.value
                        "
                        :class="
                          options.sortBy[0] === header.value &&
                          options.sortDesc[0]
                            ? $style.active
                            : ''
                        "
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-col>
                  <!-- actions column header -->
                </v-row>
                <v-list-item
                  v-for="item in items"
                  :key="item.hr_id"
                  :class="$style.listItemMain"
                >
                  <v-sheet
                    width="100%"
                    class="clickableSaafe py-4 my-2"
                    :class="$style.listItem"
                    @click="show(item)"
                  >
                    <v-row
                      :class="$style.listItemRow"
                      justify="space-between"
                      no-gutters
                    >
                      <!-- actions column value -->
                      <v-col
                        v-if="!shared && item.patient_id === null"
                        class="text-end"
                        :class="$style.actionColumn"
                      >
                        <v-menu bottom left nudge-bottom="55">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="my-auto-Saafe"
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list class="py-0" dense>
                            <v-list-item @click="show(item)">
                              <v-list-item-title>View / Edit</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="remove(item)">
                              <v-list-item-title
                                >Move to trash</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col
                        v-for="(header, index) in computeHeaders"
                        :key="header.value"
                        align-self="center"
                        cols="12"
                        :sm="columnsByIndex(index)"
                      >
                        <div
                          :class="
                            index === 0
                              ? [$style.column, $style.first]
                              : $style.column
                          "
                          class="offblack--text d-flex align-center"
                        >
                          <div class="truncate2">
                            <p :class="$style.mobileViewHeading">{{
                              $t(header.text)
                            }}</p>
                            <p :class="$style.mobileViewRecord">{{
                              validateField(header, item)
                            }}</p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- attachments row -->
                    <v-row
                      v-if="item.attachments.length"
                      :class="$style.listItemRow"
                      justify="start"
                      no-gutters
                      class="mt-2"
                    >
                      <div :class="$style.displayRow" @click.stop>
                        <v-btn
                          v-for="attachment in item.attachments"
                          :key="attachment.id"
                          rounded
                          :class="[
                            $style.borderNoneFont,
                            $vuetify.breakpoint.mobile ? 'ma-1' : 'ma-2',
                          ]"
                          outlined
                          color="primary"
                          @click.stop="preview(attachment, item.attachments)"
                        >
                          <v-icon class="my-auto-Saafe mr-2" size="15"
                            >mdi-image</v-icon
                          >

                          {{ attachment.name }}
                        </v-btn>
                      </div>
                    </v-row>
                  </v-sheet>
                </v-list-item>
              </v-list>
            </v-card-text>

            <v-btn
              v-if="!shared"
              class="ma-2"
              outlined
              color="primary"
              :class="$style.borderNone"
              @click="addItem"
              ><v-icon left> mdi-plus-circle </v-icon> Add {{ subtitle }}
            </v-btn>
          </v-card>
        </v-row>
      </v-fade-transition>
      <v-fade-transition v-else mode="out-in">
        <v-row no-gutters
          ><v-card
            v-if="expanded"
            width="100%"
            min-height="200"
            color="offwhite"
            outlined
            rounded="lg"
            loading
          >
            <template slot="progress">
              <v-progress-linear
                v-if="loading"
                color="primary"
                indeterminate
              ></v-progress-linear>
              <div v-else :class="$style.loaderPlaceholder"></div>
            </template>
            <v-card-text>
              <v-list v-if="title !== 'Symptom Checker'" color="offwhite">
                <v-row
                  class="pb-2"
                  :class="$style.headerRow"
                  justify="space-between"
                  no-gutters
                >
                  <v-col
                    v-for="(header, index) in computeHeaders"
                    :key="header.value"
                    cols="12"
                    :sm="columnsByIndex(index)"
                  >
                    <div
                      v-if="
                        header.value !== 'icon' && header.value !== 'actions'
                      "
                      class="clickableSaafe"
                      :class="
                        !options.sortBy.length ||
                        options.sortBy[0] !== header.value
                          ? ''
                          : 'font-weight-bold'
                      "
                      @mouseenter="hoverHeader = header.value"
                      @mouseleave="hoverHeader = ''"
                      @click="orderBy(header)"
                    >
                      {{ $t(header.text) }}

                      <v-icon
                        v-show="
                          options.sortBy[0] === header.value ||
                            hoverHeader === header.value
                        "
                        class="my-auto-Saafe"
                        color="primary"
                        :disabled="
                          !options.sortBy.length ||
                            options.sortBy[0] !== header.value
                        "
                        :class="
                          options.sortBy[0] === header.value &&
                          options.sortDesc[0]
                            ? $style.active
                            : ''
                        "
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-col>
                  <!-- actions column header -->
                  <v-col :class="$style.actionColumn"></v-col>
                </v-row>
                <v-list-item
                  v-for="item in items"
                  :key="item.hr_id"
                  :class="$style.listItemMain"
                >
                  <v-sheet
                    width="100%"
                    class="clickableSaafe py-4 my-2"
                    :class="$style.listItem"
                    @click="show(item)"
                  >
                    <v-row
                      :class="$style.listItemRow"
                      justify="space-between"
                      no-gutters
                    >
                      <v-col
                        v-for="(header, index) in computeHeaders"
                        :key="header.value"
                        align-self="center"
                        cols="12"
                        :sm="columnsByIndex(index)"
                      >
                        <div
                          :class="
                            index === 0
                              ? [$style.column, $style.first]
                              : $style.column
                          "
                          class="offblack--text d-flex align-center"
                        >
                          <div class="truncate2">
                            {{ validateField(header, item) }}
                          </div>
                        </div>
                      </v-col>

                      <!-- actions column value -->
                      <v-col
                        v-if="!shared && item.patient_id === null"
                        class="text-end"
                        :class="$style.actionColumn"
                      >
                        <v-menu bottom left nudge-bottom="55">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="my-auto-Saafe"
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>

                          <v-list class="py-0" dense>
                            <v-list-item @click="show(item)">
                              <v-list-item-title>View / Edit</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="remove(item)">
                              <v-list-item-title
                                >Move to trash</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <!-- attachments row -->
                    <v-row
                      v-if="item.attachments.length"
                      :class="$style.listItemRow"
                      justify="end"
                      no-gutters
                      class="mt-2"
                    >
                      <div :class="$style.displayRow" @click.stop>
                        <v-btn
                          v-for="attachment in item.attachments"
                          :key="attachment.id"
                          rounded
                          :class="[
                            $style.borderNoneFont,
                            $vuetify.breakpoint.mobile ? 'ma-1' : 'ma-2',
                          ]"
                          outlined
                          color="primary"
                          @click.stop="preview(attachment, item.attachments)"
                        >
                          <v-icon class="my-auto-Saafe mr-2" size="15"
                            >mdi-image</v-icon
                          >

                          {{ attachment.name }}
                        </v-btn>
                      </div>
                    </v-row>
                  </v-sheet>
                </v-list-item>
              </v-list>
              <div v-else>
                <label> {{ title }} Records</label>

                <v-list v-if="pdfrecords[0]" color="offwhite">
                  <v-row
                    class="pa-0"
                    :class="$style.pdfText"
                    justify="space-between"
                    no-gutters
                  ></v-row>
                  <v-row
                    v-for="document in pdfrecords"
                    :key="document.id"
                    :class="$style.pdfText"
                    justify="space-between"
                    no-gutters
                    @click="previewSympDoc(document)"
                  >
                    {{ document.document_name }}
                  </v-row>
                </v-list>
                <v-list v-else color="offwhite">
                  <v-row
                    class="pa-0"
                    :class="$style.pdfTextNo"
                    justify="space-between"
                    no-gutters
                  ></v-row>
                  <v-row> No Records Found </v-row>
                </v-list>
              </div>
            </v-card-text>

            <v-btn
              v-if="!shared & (title !== 'Symptom Checker')"
              class="ma-2"
              outlined
              color="primary"
              :class="$style.borderNone"
              @click="addItem"
              ><v-icon left> mdi-plus-circle </v-icon> Add {{ subtitle }}
            </v-btn>
          </v-card>
        </v-row>
      </v-fade-transition>
      <button id="fetchData" hidden @click="fetch"></button>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.pdfText {
  width: 100% !important;
  padding: 20px 0;
  font-size: 14px;
  font-size: 11px;
  font-weight: 600;
  line-height: 19px;
  line-height: 15px;
  color: #aaa;
  color: #0476d9;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.15000000596046448px;
  letter-spacing: 1.5px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}
.pdfTextNo {
  justify-content: center;
  width: 100% !important;
  padding: 20px 0;
  font-size: 14px;
  font-size: 11px;
  font-weight: 600;
  line-height: 19px;
  line-height: 15px;
  color: #aaa;
  color: #0476d9;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.15000000596046448px;
  letter-spacing: 1.5px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}
.active {
  transform: rotate(-180deg);
}

.listItem {
  background: #fcfcfc !important;
  border-radius: 8px !important;
}

.column {
  font-size: 14px;
  line-height: 19px;
  color: #454648;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
.mobileViewHeading {
  margin-bottom: 5px !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.first {
  max-width: 100%;
  font-weight: 600;
}

.actionColumn {
  max-width: 40px;
}

.headerRow {
  width: 100% !important;
  font-size: 11px;
  font-weight: 600;
  line-height: 15px;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-bottom: 1px solid #ccc;
}

.listItemRow {
  width: 100% !important;
}

.title {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.loaderPlaceholder {
  height: 4px;
}

.iconRow {
  height: 100%;
}

.iconContainer {
  border-radius: 3px;
}

.attachmentBtn {
  border: 1px solid $color-theme-light-placehold;
  border-radius: 24px !important;
}

.attachmentBtnText {
  max-width: 100px;
  font-size: 13px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.25px;
}

.listItemMain {
  padding: 0;
  border-bottom: 1px solid #ccc;
}

.addButtonDiv {
  margin: 0 15px;
  border-bottom: 1px solid #ccc;
  border-radius: 0 !important;
}
.containerClass {
  margin: 10px 0;
  background: #fcfcfc;
  border: 1px solid #93c0e8;
  border-radius: 5px;
}
.borderNoneFont {
  font-size: 10px !important;
}
.borderNone {
  text-transform: capitalize;
  border: 0;
}
.truncate2 {
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  color: #454648;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
.mobileViewRecord {
  margin: 0 0 15px !important;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #454648;
  text-transform: capitalize;
  letter-spacing: 0.15px;
}
@media screen and (max-width: 599px) {
  .actionColumn {
    position: absolute;
    right: 0;
    max-width: 40px;
  }
}
@media screen and (max-width: 479px) {
  .containerClass {
    margin: 10px 0;
  }
}
</style>

<style scoped>
/deep/ .v-btn > .v-btn__content .v-icon.mdi-dots-vertical {
  color: #0476d9 !important;
}
</style>
